import { render, staticRenderFns } from "./TableActiveFilters.vue?vue&type=template&id=ffb9d814"
import script from "./TableActiveFilters.vue?vue&type=script&lang=js"
export * from "./TableActiveFilters.vue?vue&type=script&lang=js"
import style0 from "./TableActiveFilters.vue?vue&type=style&index=0&id=ffb9d814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports